"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WYSIWYG_MINIMAL_TOOLBAR = exports.WYSIWYG_FULL_TOOLBAR = void 0;
var WYSIWYG_FULL_TOOLBAR = [["bold", "italic", "underline"],
// toggled buttons
["link", "blockquote", "code-block"], [{
  list: "ordered"
}, {
  list: "bullet"
}], [{
  size: ["small", false, "large", "huge"]
}],
// custom dropdown
[{
  header: [1, 2, 3, 4, 5, 6, false]
}], [{
  color: []
}, {
  background: []
}],
// dropdown with defaults from theme
[{
  align: []
}], ["clean"] // remove formatting button
];
exports.WYSIWYG_FULL_TOOLBAR = WYSIWYG_FULL_TOOLBAR;
var WYSIWYG_MINIMAL_TOOLBAR = [["bold", "italic", "underline"],
// toggled buttons
["link"], [{
  list: "ordered"
}, {
  list: "bullet"
}], [{
  size: ["small", false]
}],
// custom dropdown
["clean"] // remove formatting button
];
exports.WYSIWYG_MINIMAL_TOOLBAR = WYSIWYG_MINIMAL_TOOLBAR;